import {
  dateToApiFormat,
  getDaysInMonth,
  isDateInPast,
  isTodayUTCMatch,
  localDateToUtcDate
} from '@/helpers/dateHelper';
import { FC, useEffect, useRef } from 'react';
import { CalendarProps } from './calendar.types';

export const MobileCalendar: FC<CalendarProps> = ({ monthToShow, events, ContentComponent }) => {
  const daysInAMonth = getDaysInMonth(monthToShow.getUTCMonth(), monthToShow.getUTCFullYear());
  const todayRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (todayRef.current) {
      todayRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [monthToShow]);

  return (
    <div>
      <div className="flex flex-col space-y-2 cursor-pointer">
        {daysInAMonth.map(date => {
          const weekday = date.toLocaleDateString('en-GB', { weekday: 'short', timeZone: 'utc' });
          const currentKey = dateToApiFormat(date);
          const event = events?.find(e => dateToApiFormat(e.date) === currentKey);

          const isPastDate = isDateInPast(date, new Date());
          const isTodayDate = isTodayUTCMatch(date);

          const isFutureDate = !isPastDate && !isTodayDate;

          return (
            <div
              onClick={event?.contextObject.onClick}
              ref={isTodayDate ? todayRef : undefined}
              key={date.toISOString()}
              className={`flex items-stretch rounded-lg border relative overflow-hidden`}
            >
              {isPastDate && <div className="absolute h-full w-full bg-gray-500 opacity-10"></div>}
              <div
                className={`w-16 flex flex-col items-center justify-center p-2 ${isPastDate && 'bg-gray-300'} ${
                  isTodayDate && 'bg-primary-500 text-white'
                } ${isFutureDate && 'bg-gray-100'}`}
              >
                <span className="text-xl font-semibold">{date.getUTCDate()}</span>
                <span className={`${isTodayDate ? 'text-white' : 'text-gray-500 '} text-sm font-semibold`}>
                  {weekday}
                </span>
              </div>

              <div className="flex-1 bg-white">
                <ContentComponent date={date} contextObject={event?.contextObject} today={isTodayDate} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
